var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_23228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.88 18.4701C20.36 17.7001 20.63 16.8001 20.57 15.8101C20.44 13.6601 18.73 11.8401 16.6 11.6101C13.88 11.3101 11.58 13.4201 11.58 16.0801C11.58 18.5701 13.59 20.5801 16.07 20.5801C16.95 20.5801 17.77 20.3201 18.46 19.8801L20.87 22.2901C21.26 22.6801 21.9 22.6801 22.29 22.2901C22.68 21.9001 22.68 21.2601 22.29 20.8701L19.88 18.4701ZM16.08 18.5801C14.7 18.5801 13.58 17.4601 13.58 16.0801C13.58 14.7001 14.7 13.5801 16.08 13.5801C17.46 13.5801 18.58 14.7001 18.58 16.0801C18.58 17.4601 17.46 18.5801 16.08 18.5801ZM15.72 10.0801C14.98 10.1001 14.27 10.2601 13.62 10.5301L13.07 9.70005L9.98998 14.7101C9.62998 15.2901 8.81999 15.3501 8.37999 14.8401L6.25999 12.3701L3.19999 17.2701C2.88999 17.7601 2.22998 17.8901 1.75998 17.5501C1.33998 17.2401 1.21998 16.6601 1.49998 16.2101L5.27999 10.1601C5.63999 9.59005 6.44999 9.53005 6.88999 10.0401L8.99999 12.5001L12.18 7.33005C12.56 6.71005 13.46 6.69005 13.86 7.30005L15.72 10.0801ZM18.31 10.5801C17.67 10.3001 16.98 10.1301 16.26 10.0901L20.8 2.90005C21.11 2.41005 21.77 2.29005 22.23 2.63005C22.66 2.94005 22.77 3.53005 22.49 3.97005L18.31 10.5801Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_23228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartNoData);
export default __webpack_public_path__ + "static/media/ChartNoData.49226fa67a9286e3230c5eccf9f05284.svg";
export { ForwardRef as ReactComponent };